"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.filterAsyncRoutes = filterAsyncRoutes;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.replace");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _router = require("@/router");
var _menu = require("@/api/system/menu");
var _config = _interopRequireDefault(require("@/utils/config"));
var _layout = _interopRequireDefault(require("@/layout"));
var env = process.env.NODE_ENV; // pack env
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(function (role) {
      return route.meta.roles.includes(role);
    });
  } else {
    return true;
  }
}

/* 遍历router map */
function flatten(data) {
  var _iterator = (0, _createForOfIteratorHelper2.default)(data),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      if (item.component) {
        if (item.component === 'layout') {
          item['component'] = _layout.default;
        } else {
          var sub_view = item.component;
          sub_view = sub_view.replace(/^\/*/g, '');
          /* 加载组件, 如报错则加载404页面 */
          try {
            item.component = require("@/views/".concat(sub_view)).default;
          } catch (e) {
            // console.log(e)
            item.component = require('@/views/common/error-page/404').default;
          }
        }
      }
      if (item.children && item.children.length !== 0) {
        var redirectUrl = '';
        var flag = false;
        var _iterator2 = (0, _createForOfIteratorHelper2.default)(item.children),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var sItem = _step2.value;
            if (sItem.path === item.redirect) {
              flag = true;
              break;
            }
            if (!sItem.hidden && redirectUrl === '') {
              redirectUrl = sItem.path;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        if (!flag) {
          item.redirect = redirectUrl;
        }
        flatten(item.children);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return data;
}
function flattenRoleRoutes(data) {
  var _iterator3 = (0, _createForOfIteratorHelper2.default)(data),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var item = _step3.value;
      if (item.component) {
        if (item.component === 'layout') {
          item['component'] = _layout.default;
        } else {
          var sub_view = item.component;
          sub_view = sub_view.replace(/^\/*/g, '');
          /* 加载组件, 如报错则加载404页面 */
          try {
            item.component = require("@/views/".concat(sub_view)).default;
          } catch (e) {
            // console.log(e)
            item.component = require('@/views/common/error-page/404').default;
          }
        }
        // 处理meta
        var meta = {};
        meta.title = item.title;
        meta.titleCn = item.titleCn;
        meta.titleEn = item.titleEn;
        meta.icon = item.icon;
        if (!item.noCache) {
          meta.keepAlive = true;
        } else {
          meta.keepAlive = false;
        }
        if (item.activeMenu) meta.activeMenu = item.activeMenu;
        item.meta = meta;
        delete item.title;
        delete item.icon;
        delete item.activeMenu;
      }
      if (item.children && item.children.length !== 0) {
        /* 设置重定向地址,默认为第一个 */
        var redirectUrl = '';
        var flag = false;
        var _iterator4 = (0, _createForOfIteratorHelper2.default)(item.children),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var sItem = _step4.value;
            if (sItem.path === item.redirect) {
              flag = true;
              break;
            }
            if (!sItem.hidden && redirectUrl === '') {
              redirectUrl = sItem.path;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        if (!flag) {
          item.redirect = redirectUrl;
        }
        flattenRoleRoutes(item.children);
      } else {
        delete item.children;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return data;
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
function filterAsyncRoutes(routes, roles) {
  var res = [];
  routes.forEach(function (route) {
    var tmp = (0, _objectSpread2.default)({}, route);
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });
  return res;
}
var state = {
  routes: [],
  addRoutes: [],
  tabRoutes: []
};
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = _router.constantRoutes.concat(routes);
  },
  GET_TAB_ROUTES: function GET_TAB_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.tabRoutes = routes;
  }
};
var actions = {
  generateRoutes: function generateRoutes(_ref) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      var accessedRoutes;
      // const type = 'mock' // 使用mock
      (0, _menu.getRoleMenu)({
        appCode: _config.default.appCode
      }).then(function (res) {
        if (res.success) {
          accessedRoutes = flattenRoleRoutes(res.result || []);
          console.log('accessedRoutes', accessedRoutes);
          // 加404 判断
          accessedRoutes.push({
            path: '*',
            redirect: '/404',
            hidden: true
          });
          commit('SET_ROUTES', accessedRoutes);
          resolve(accessedRoutes);
        }
      }).catch(function (err) {
        console.log(err);
      });
    });
  },
  getTabRoutes: function getTabRoutes(_ref2, item) {
    var commit = _ref2.commit;
    return new Promise(function (resolve) {
      var accessedRoutes;
      (0, _menu.getRoleMenu)({
        appCode: _config.default.appCode,
        modelId: item.id
      }).then(function (res) {
        if (res.success) {
          accessedRoutes = res.result || [];
          commit('GET_TAB_ROUTES', accessedRoutes);
          resolve(accessedRoutes);
        }
      }).catch(function (err) {
        console.log(err);
      });
    });
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};